import React from 'react';
import { DesktopMenuItem } from '../desktop-menu-item/DesktopMenuItem';
import { notifyAnalytics } from '../notify-analytics';
import styles from './DesktopMenu.scss';

type DesktopMenuPanelProps = {
  activeTab?: string;
  menuItems: MenuItem[];
  activeIndex: number;
  focusableIndex?: number;
  onSelect: (index: number) => void;
  onClose: () => void;
  onNavigate?: (index: number, direction: string) => void;
  onTabNavigate?: (
    event: React.KeyboardEvent<HTMLElement>,
    index: number
  ) => void;
};

export const DesktopMenuPanel = ({
  activeTab,
  menuItems,
  activeIndex,
  onSelect,
  onClose,
  onNavigate = () => {},
  onTabNavigate = () => {},
}: DesktopMenuPanelProps) => {
  return (
    <div
      className={styles.desktopMenuPanel}
      id="desktop-menu-panel"
      data-testid="desktop-menu-panel"
    >
      <ul className={styles.desktopMenuPanelList}>
        {menuItems.map((item, index) => (
          <DesktopMenuItem
            key={item.id}
            label={item.name}
            url={item.url}
            active={activeIndex === index}
            onSelect={() => onSelect(index)}
            onClose={onClose}
            tabIndex={0}
            onNavigate={direction => onNavigate(index, direction)}
            onTabNavigate={event => onTabNavigate(event, index)}
            hasChildData={item?.child?.length > 0}
            onLinkClick={() => notifyAnalytics(`${activeTab}|${item.name}`)}
          />
        ))}
      </ul>
    </div>
  );
};
